import { render, staticRenderFns } from "./IndexSwiper.vue?vue&type=template&id=09df9e4a"
import script from "./IndexSwiper.vue?vue&type=script&lang=js"
export * from "./IndexSwiper.vue?vue&type=script&lang=js"
import style0 from "./IndexSwiper.vue?vue&type=style&index=0&id=09df9e4a&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports